export const menu= [
  {
    relationId: 'e4c29691e5764004ae6e010c772feaec',
    tenantId: '2187446411731812457',
    menuId: '1385104164398706689',
    menuName: 'AI-体验馆',
    menuPath: '/experienceHall',
    createBy: '1338416359818851225',
    createTime: '2021-04-22 13:43:04',
    updateBy: '1338416359818851225',
    updateTime: '2021-04-22 13:43:04',
  },
  {
    relationId: 'f982cd83dcd04afeb5451e05f9b8e58a',
    tenantId: '2187446411731812457',
    menuId: '1385103972597379073',
    menuName: '行业应用',
    menuPath: '/industryApplication',
    createBy: '1338416359818851225',
    createTime: '2021-04-22 13:43:04',
    updateBy: '1338416359818851225',
    updateTime: '2021-04-22 13:43:04',
  },
  {
    relationId: 'fa537ecc9377483e9229ed10e2b566b0',
    tenantId: '2187446411731812457',
    menuId: '1385103788219969538',
    menuName: 'AI-T编辑器',
    menuPath: '/editor',
    createBy: '1338416359818851225',
    createTime: '2021-04-22 13:43:04',
    updateBy: '1338416359818851225',
    updateTime: '2021-04-22 13:43:04',
  },
  {
    relationId: 'fab0f6cfe38a43eb9fd0b78f4f5b3b03',
    tenantId: '2187446411731812457',
    menuId: '1385103238749368321',
    menuName: '实训中心',
    menuPath: '/trainingCenter',
    createBy: '1338416359818851225',
    createTime: '2021-04-22 13:43:04',
    updateBy: '1338416359818851225',
    updateTime: '2021-04-22 13:43:04',
  },
  {
    relationId: '18170563ede34a029950a7e65d32222e',
    tenantId: '2187446411731812457',
    menuId: '1385102916417105921',
    menuName: '教学中心',
    menuPath: '/teachingCenter',
    createBy: '1338416359818851225',
    createTime: '2021-04-22 13:43:04',
    updateBy: '1338416359818851225',
    updateTime: '2021-04-22 13:43:04',
  },
  {
    relationId: '21a9b24f7b12417380dd69a92bc4ad6e',
    tenantId: '2187446411731812457',
    menuId: '1385102761697619970',
    menuName: '首页',
    menuPath: '/homePage',
    createBy: '1338416359818851225',
    createTime: '2021-04-22 13:43:04',
    updateBy: '1338416359818851225',
    updateTime: '2021-04-22 13:43:04',
  },
  {
    relationId: '15ebb718cbce4b5cb185bd9b3e3bc21b',
    tenantId: '2187446411731812457',
    menuId: '1385103497240129538',
    menuName: '模型训练',
    menuPath: '/modelTraining',
    createBy: '1338416359818851225',
    createTime: '2021-04-22 13:43:04',
    updateBy: '1338416359818851225',
    updateTime: '2021-04-22 13:43:04',
  },
  {
    relationId: '2ad31fc156eb4649b18f594fbc933473',
    tenantId: '2187446411731812457',
    menuId: '1385105415123382273',
    menuName: '智能硬件',
    menuPath: '/intelligentHardware',
    createBy: '1338416359818851225',
    createTime: '2021-04-22 13:43:04',
    updateBy: '1338416359818851225',
    updateTime: '2021-04-22 13:43:04',
  },
  {
    relationId: '39c9e7082ba74e5f9ca76328bf363107',
    tenantId: '2187446411731812457',
    menuId: '1385104746618433538',
    menuName: 'python',
    menuPath: '/python',
    createBy: '1338416359818851225',
    createTime: '2021-04-22 13:43:04',
    updateBy: '1338416359818851225',
    updateTime: '2021-04-22 13:43:04',
  },
  {
    relationId: '8087dbe1d1ca42f9bc67974c6050b7bb',
    tenantId: '2187446411731812457',
    menuId: '1385104591865393154',
    menuName: '海龟库',
    menuPath: '/turtleBank',
    createBy: '1338416359818851225',
    createTime: '2021-04-22 13:43:04',
    updateBy: '1338416359818851225',
    updateTime: '2021-04-22 13:43:04',
  },
  {
    relationId: 'f369bcd72a714b1598ff1a60fb159837',
    tenantId: '2187446411731812457',
    menuId: '1385104282376089602',
    menuName: 'AI-T',
    menuPath: '/aiT',
    createBy: '1338416359818851225',
    createTime: '2021-04-22 13:43:04',
    updateBy: '1338416359818851225',
    updateTime: '2021-04-22 13:43:04',
  },
]